(function () {
  var FIELD_QUERY = /^(?:title|id|tag|vendor|product_type|sku|barcode):/i;

  function isStructuredQuery(value) {
    return FIELD_QUERY.test(value) || value.indexOf(' OR ') !== -1 || value.indexOf(' AND ') !== -1;
  }

  function scopeQuery(value) {
    return 'title:"' + value.replace(/"/g, '') + '"';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var value = input.value.trim();
      if (!value || isStructuredQuery(value)) return;

      input.value = scopeQuery(value);
    },
    true
  );

  if (!window.themeVariables || window.themeVariables.settings.pageType !== 'search') return;

  var params = new URLSearchParams(window.location.search);
  var currentQuery = (params.get('q') || '').trim();
  if (!currentQuery || isStructuredQuery(currentQuery)) return;

  params.delete('page');
  params.set('q', scopeQuery(currentQuery));
  window.location.replace(window.location.pathname + '?' + params.toString());
})();
